import { Deposito } from './../../../../models/cad/deposito/deposito';
import { Component, Injector, OnInit, Inject,ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Acesso } from 'src/app/models/bas/acesso/acesso';
import { Cliente } from 'src/app/models/cad/cliente/cliente';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { TrataExcessao } from 'src/app/shared/utils/trata-excessao';
import { DepositoService } from 'src/app/services/cad/deposito.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { EstoqueService } from 'src/app/services/est/estoque.service';
import { MatTableDataSource } from '@angular/material/table';
import { Estoque } from 'src/app/models/est/estoque/estoque';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-filtro-estoque',
  templateUrl: './filtro-estoque.component.html',
  styleUrls: ['./filtro-estoque.component.scss']
})
export class FiltroEstoqueComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ViewChild("inputFiltro") inputFiltro: ElementRef;
  dataSourceEtiqueta = new MatTableDataSource<never>();

  selectedEstoque: Estoque | null = null;

  filterObject = {
    depositos:[{
      deposito: [],
      nomeDeposito: [],
    }],
    dataReferencia: []
  };


  dataSource = new MatTableDataSource<Estoque>();

  dialogRef: MatDialogRef<FiltroEstoqueComponent>;


  private dialogData;

  form: UntypedFormGroup;
  cliente: Cliente;

  isLoading = false;
  acesso: Acesso | undefined = undefined;
  countLoading = 0;
  nameDeposito

  separatorKeysCodes: number[] = [ENTER, COMMA];

  listaDeposito: Array<Deposito> = [];
  listaTodosDepositos: Array<Deposito> = [];
  listaDepositoFiltrados: Array<Deposito> = [];

  depositoSelecionado: boolean = false;
  registro;

  constructor(
    private injector: Injector,
    private formBuilder: UntypedFormBuilder,
    private snackBar: CustomSnackBarService,
    private authService: AuthService,
    private depositoService: DepositoService,
    private service: EstoqueService,
    @Inject(SESSION_STORAGE) private storage: StorageService

  ) {

    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      deposito: [, /*Validators.required*/],
      nomeDeposito: [,],
      dataReferencia: [,],
    });
  }

  

  private pesquisarDeposito() {
    this.exibirCarregando();
    this.depositoService.listarTodos().subscribe((response) => {
      this.escondeCarregando();
      if (response.body.retorno) { 
        
        for (let i of response.body.retorno.registro) {
          //salvando todos os registros em um array
          this.listaTodosDepositos.push(i); 
          this.listaDeposito = [...this.listaDeposito, i.nomeDeposito];          
        }

        if (this.dialogData['nomeDeposito']) {
          const depositoSelecionados = this.dialogData['nomeDeposito'];
         
          this.listaDepositoFiltrados = depositoSelecionados;
          for (let j of depositoSelecionados) {
            const element = this.listaDeposito.find((item) => item === j);
            if (element) {
              const index = this.listaDeposito.indexOf(element);
              this.listaDeposito.splice(index, 1);
            }
          }
        }
      }
    }, (err) => {
      this.escondeCarregando();
      TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
    }
    );
  }

  saveInSession(key, val): void {
    this.storage.set(key, val);
  }

  listaEstoqueAtivo(result?: Array<any>) {
    if (result) {
      this.dataSource = new MatTableDataSource<Estoque>(result);
      return;
    }
    this.exibirCarregando()
    this.saveInSession("filtroEstoque", this.filterObject);
    this.service.listarEstoqueAtivo(this.filterObject).subscribe(
      (response) => {
        this.escondeCarregando();
        this.dataSource = new MatTableDataSource<Estoque>(response.body.retorno.registro);
        this.registro = response.body.retorno.registro;
        setTimeout(() => {
          this.dataSource.filterPredicate = (
            data: { nomeDeposito: string; },
            filterValue: string
          ) => data.nomeDeposito.toString().trim().toLowerCase().indexOf(filterValue) !== -1

          var filtroBuscar = this.getFromSession("filtroBuscarEstoque");  
          if (filtroBuscar) {
            this.inputFiltro.nativeElement.value = filtroBuscar;
            this.applyFilter(filtroBuscar); 
          } 

          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.trataRetornoPesquisaEstoque();
      },
      (err) => {
        this.escondeCarregando();
        TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
      }
    );
  }
  

  trataRetornoPesquisaEstoque() {
    setTimeout(() => {
      this.dataSource.filterPredicate = (
        data: {
          produtoCod: string,
          nomeProduto: string,
          nomeDeposito: string,
          quantidadeRequisitada: string,
        },
        filterValue: string
      ) => data.nomeProduto.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.produtoCod.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.nomeDeposito.toString().trim().toLowerCase().indexOf(filterValue) !== -1 ||
           data.quantidadeRequisitada.toString().trim().toLowerCase().indexOf(filterValue) !== -1 


      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

    //Manter Aberto Estoque Que Foi Detalhado
    var achouListada = false;

    this.dataSource.data.forEach((estoque) => {
      if (estoque.codigoEstoque === this.selectedEstoque?.codigoEstoque) {
        this.selectedEstoque = estoque;
        this.groupHeaderClick(estoque);
        achouListada = true;
      }
    });

    if (!achouListada) {
      this.selectedEstoque = null;
    }
  }

  displayDeposito(deposito: Deposito): any {
    return deposito && deposito.nomeDeposito ? deposito.nomeDeposito : '';
  }

  groupHeaderClick(row: Estoque) {
    row.expanded = !row.expanded;

    if (row.expanded) {
      this.selectedEstoque = row;
    }
    else {
      this.selectedEstoque = null;
    }

    this.dataSourceEtiqueta = new MatTableDataSource<never>(row.etiquetas);

    this.dataSource.data.forEach((estoque) => {
      if (estoque.codigoEstoque != row.codigoEstoque) {
        estoque.expanded = false;
      }
    });

  }

  applyFilter(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
    this.saveInSession("filtroBuscarEstoque", value.trim().toLowerCase());
  }


  selecionaDeposito(event) {
    let selecionado: Deposito = event.option.value;
    this.listaDepositoFiltrados.push(selecionado);
    const index = this.listaDeposito.indexOf(selecionado);
    if (index >= 0) {
      this.listaDeposito.splice(index, 1);
    }
  }

  remove(nomeDeposito: any): void {
    this.listaDeposito.push(nomeDeposito);
    const index = this.listaDepositoFiltrados.indexOf(nomeDeposito);
    if (index >= 0) {
      this.listaDepositoFiltrados.splice(index, 1);
    }
  }

  private preencheCombos() {
    this.pesquisarDeposito();
  }

  private exibirCarregando() {
    this.countLoading++;
    this.isLoading = true;
  }

  private escondeCarregando() {
    this.countLoading--;
    if (this.countLoading <= 0) {
      this.isLoading = false;
    }
  }


  /*closeModal() {
    
    let gridRegistrosFiltrados: Array<any> = [];
    if (this.listaDepositoFiltrados.length > 0) {
      const filtro = { nomeDeposito: this.listaDepositoFiltrados }
      for (let j of this.dialogData.registros) {
        const registro = this.listaDepositoFiltrados.find((item) => item === j.nomeDeposito);
        if (registro) {
          gridRegistrosFiltrados.push(j);
        }
        this.dialogRef.close({ gridRegistrosFiltrados, filtro });
      }
    } else {
      this.dialogRef.close();
    }

  }*/
    closeModal() {
      if(this.form.valid){
        const obj = this.form.getRawValue();

        let params: Array<any> = []; 

        if (this.listaDepositoFiltrados.length > 0) {
          this.filterObject["nomeDeposito"].pop();
          for (let j of this.dialogData.nomeDeposito) {
            const registro = this.listaTodosDepositos.find((item) => item.nomeDeposito === j);
            if (registro) {              
              obj.deposito = registro.codigoDeposito;
              obj.nomeDeposito = registro.nomeDeposito;
              this.filterObject["nomeDeposito"].push(
                {
                  deposito: obj.deposito,
                  nomeDeposito: obj.nomeDeposito

                }
              );
            }
          }
          
        }
        
        if(obj.dataReferencia){

        }
        
        this.filterObject.dataReferencia = obj.dataReferencia;

        this.listaEstoqueAtivo();
        /*
        const keys = Object.keys(obj).map(key => key);
        for(let i of keys){
          if((!obj[i]) || (typeof(obj[i]) === 'object')){
            delete obj[i];
          }
        }
        filterObject.filters = obj;
        const date = new Date(obj.dataHoraFinalMovimento);
        this.dialogRef.close(filterObject);*/
      } else {
        this.snackBar.openSnackBar('Campos obrigatórios não foram preenchidos.', 'Error');
      }
      }

  getFromSession(key): any {
    return this.storage.get(key);
  }

  ngOnInit(): void {
    this.createForm();
    this.preencheCombos();
    this.form.controls['nomeDeposito'].valueChanges.subscribe(deposito => {
      if (deposito === "") {
        this.form.controls['nomeDeposito'].setValue(null);
      }
    })
    var aux = this.getFromSession("filtroEstoque");
    if (aux)
      this.filterObject = aux;

  }

}
